import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import OrangeBySiteStandaloneHeader from "@/components/OrangeBySiteStandaloneHeader";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/unsubscribe`;

export default function Unsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, info: null, done: false, error: null });

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/${encodeURIComponent(token)}`)
      .then((r) => alive && setState({ loading: false, info: r.data, done: false, error: null }))
      .catch((err) => alive && setState({ loading: false, info: null, done: false, error: err?.response?.data?.detail || "Link not recognised" }));
    return () => { alive = false; };
  }, [token]);

  async function confirm() {
    try {
      await axios.post(`${API}/${encodeURIComponent(token)}`, { scope: "EMAIL" });
      setState((s) => ({ ...s, done: true }));
    } catch (err) {
      setState((s) => ({ ...s, error: err?.response?.data?.detail || "Failed to unsubscribe" }));
    }
  }

  return (
    <div className="min-h-screen bg-[#F6F5F2]" data-testid="unsubscribe-root">
      <OrangeBySiteStandaloneHeader />
      <div className="max-w-lg mx-auto px-6 py-16">
        <div className="bg-white border border-[#EAEAEA] rounded-2xl p-8">
          <div className="text-[10px] tracking-[0.28em] uppercase font-bold text-[#FF6A00]">OrangeBySite</div>
          <h1 className="mt-2 font-black text-2xl tracking-[-0.01em]">Unsubscribe</h1>

          {state.loading && <p className="mt-4 text-[#8A8A8A]" data-testid="unsubscribe-loading">Loading…</p>}

          {state.error && (
            <p className="mt-4 text-[#C1350B]" data-testid="unsubscribe-error">{state.error}</p>
          )}

          {!state.loading && !state.error && !state.done && state.info && (
            <>
              <p className="mt-4 text-[15px] text-[#0A0A0A]">
                You're about to unsubscribe <strong>{state.info.email_masked}</strong> from OrangeBySite marketing emails.
              </p>
              <p className="mt-2 text-[13px] text-[#8A8A8A]">Transactional messages (like order confirmations) are separate and won't be affected.</p>
              {state.info.already_used && (
                <p className="mt-3 text-[13px] text-[#0FA958]" data-testid="unsubscribe-already">This link has already been used — you're not receiving marketing emails from us.</p>
              )}
              <button
                onClick={confirm}
                data-testid="unsubscribe-confirm"
                className="mt-6 px-6 py-3 rounded-full bg-[#0A0A0A] text-white text-[12px] font-black tracking-[0.18em] uppercase"
              >Unsubscribe me</button>
            </>
          )}

          {state.done && (
            <div className="mt-4" data-testid="unsubscribe-done">
              <p className="text-[15px] font-black text-[#0FA958]">You're unsubscribed.</p>
              <p className="mt-2 text-[13px] text-[#8A8A8A]">We won't send you any more marketing emails.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
